import { useState, useEffect } from 'react';

export const useDocumentActive = (): boolean => {
	const [isActive, setIsActive] = useState<boolean>(document.visibilityState === 'visible');
	const delay = 2000; // 2 seconds delay

	useEffect(() => {
		let timer: NodeJS.Timeout;

		const handleVisibilityChange = () => {
			clearTimeout(timer);

			if (document.visibilityState === 'visible') {
				timer = setTimeout(() => {
					setIsActive(true);
				}, delay);
			} else {
				setIsActive(false);
			}
		};

		document.addEventListener('visibilitychange', handleVisibilityChange);

		return () => {
			clearTimeout(timer);
			document.removeEventListener('visibilitychange', handleVisibilityChange);
		};
	}, []);

	return isActive;
};
